/**
 * Categories (Classic) — motion vocabulary.
 *
 * Choreographed for a stage-presentation feel: tiles snap forward decisively,
 * the clue lands with a measured zoom, the Daily Double has a confident
 * bloom-and-settle. Springs are tighter than the notebook (more "TV studio
 * confidence"), with one overshoot moment per choreography.
 */

import { easing, timings } from '@/juice';

/** Page-entrance spring — board panel rises. Calm, confident. */
export const pageSpring = {
  type: 'spring' as const,
  stiffness: 200,
  damping: 26,
  mass: 1.0,
};

/** Hub card spring — gentle hover lift. */
export const cardSpring = {
  type: 'spring' as const,
  stiffness: 260,
  damping: 24,
  mass: 0.9,
};

/** Tile press feedback — quick snap. */
export const pressSpring = {
  type: 'spring' as const,
  stiffness: 460,
  damping: 32,
  mass: 0.6,
};

/** Tile-to-clue zoom — the dramatic forward push. */
export const zoomSpring = {
  type: 'spring' as const,
  stiffness: 220,
  damping: 22,
  mass: 0.85,
};

/** Daily Double bloom — bigger spring overshoot. */
export const bloomSpring = {
  type: 'spring' as const,
  stiffness: 180,
  damping: 14,
  mass: 0.9,
};

/** Settle after a celebration beat (correct answer). */
export const celebrateSpring = {
  type: 'spring' as const,
  stiffness: 320,
  damping: 18,
  mass: 0.7,
};

/** Stagger for sequential beats (tile reveals, summary entries). */
export const STAGGER_S = 0.06;

/** Choreography timings (ms). */
export const CHOREO = {
  tileZoom: 600,
  clueHold: 240,
  dailyDoubleZoom: 1200,
  revealHold: 1400,
  scoreCountUp: 900,
  endBoardFade: 600,
} as const;

export { easing, timings };
